export const footerMoreLinks = {
  'pl-ru': [
    {
      title: 'более',
      items: [
        {
          href: 'https://www.wingie.pl/contact/',
          title: 'Контакты',
        },
        {
          href: 'https://www.wingie.pl/faq/',
          title: 'Часто задаваемые вопросы',
        },

        {
          href: 'https://www.wingie.pl/about-us/',
          title: 'О нас',
        },
        {
          href: 'https://www.wingie.pl/privacy/',
          title: 'Конфиденциальность',
        },
        {
          href: 'https://www.wingie.pl/terms-and-conditions/',
          title: 'Условия и положения',
        },
        {
          href: 'https://www.wingie.pl/awards/',
          title: 'Наши награды',
        },
      ],
    },
  ],
  'pl-en': [
    {
      title: 'More',
      items: [
        {
          href: 'https://www.wingie.pl/en/contact/',
          title: 'Contact',
        },
        {
          href: 'https://www.wingie.pl/en/faq/',
          title: 'Frequently Asked Questions',
        },

        {
          href: 'https://www.wingie.pl/en/about-us/',
          title: 'About us',
        },
        {
          href: 'https://www.wingie.pl/en/privacy/',
          title: 'Privacy',
        },
        {
          href: 'https://www.wingie.pl/en/terms-and-conditions/',
          title: 'Terms and Conditions',
        },
        {
          href: 'https://www.wingie.pl/en/awards/',
          title: 'Our Awards',
        },
      ],
    },
  ],
  'pl-es': [
    {
      title: 'Más',
      items: [
        {
          href: 'https://www.wingie.pl/es/contacto/',
          title: 'Contacto',
        },
        {
          href: 'https://www.wingie.pl/es/preguntas-frecuentes/',
          title: 'Preguntas más frecuentes',
        },

        {
          href: 'https://www.wingie.pl/es/acerca-de-nosotros/',
          title: 'Sobre nosotros',
        },
        {
          href: 'https://www.wingie.pl/es/privacidad/',
          title: 'Privacidad',
        },
        {
          href: 'https://www.wingie.pl/es/terminos-y-condiciones/',
          title: 'Términos y condiciones de uso',
        },
        {
          href: 'https://www.wingie.pl/es/awards/',
          title: 'Nuestros premios',
        },
      ],
    },
  ],
  'pl-de': [
    {
      title: 'Mehr',
      items: [
        {
          href: 'https://www.wingie.pl/de/kontakt/',
          title: 'Kontakt',
        },
        {
          href: 'https://www.wingie.pl/de/faq/',
          title: 'Häufig gestellte Fragen - Wingie',
        },

        {
          href: 'https://www.wingie.pl/de/uber-uns/',
          title: 'Über uns',
        },
        {
          href: 'https://www.wingie.pl/de/datenschutz/',
          title: 'Datenschutz & Cookies',
        },
        {
          href: 'https://www.wingie.pl/de/allgemeine-geschaeftsbedingungen/',
          title: 'Allgemeine Geschäftsbedingungen',
        },
        {
          href: 'https://www.wingie.pl/de/awards/',
          title: 'Unsere Auszeichnungen',
        },
      ],
    },
  ],
  'pl-ar': [
    {
      title: 'أكثر',
      items: [
        {
          href: 'https://www.wingie.pl/ar/contact/',
          title: 'التواصل',
        },
        {
          href: 'https://www.wingie.pl/ar/faq/',
          title: 'الأسئلة المتكررة',
        },
        {
          href: 'https://www.wingie.pl/ar/about-us/',
          title: 'تعرّف علينا',
        },
        {
          href: 'https://www.wingie.pl/ar/privacy/',
          title: 'الخصوصية - وينجي',
        },
        {
          href: 'https://www.wingie.pl/ar/terms-and-conditions/',
          title: 'شروط الاستخدام',
        },
        {
          href: 'https://www.wingie.pl/ar/awards/',
          title: 'جوائزنا',
        },
      ],
    },
  ],
  'pl-it': [
    {
      title: 'Di più',
      items: [
        { href: 'https://www.wingie.pl/it/contact/', title: 'Contatti' },
        // { href: 'https://www.wingie.pl/it/faq/', title: 'Domande frequenti' },

        { href: 'https://www.wingie.pl/it/about-us/', title: 'Chi siamo' },
        { href: 'https://www.wingie.pl/it/privacy/', title: 'Privacy' },
        { href: 'https://www.wingie.pl/it/terms-and-conditions/', title: 'Termini e condizioni' },
        { href: 'https://www.wingie.pl/it/awards/', title: 'I nostri premi' },
      ],
    },
  ],
  'pl-fr': [
    {
      title: 'Plus',
      items: [
        { href: 'https://www.wingie.pl/fr/contact/', title: 'Contact' },
        // { href: 'https://www.wingie.pl/fr/faq/', title: 'Questions fréquemment posées' },

        { href: 'https://www.wingie.pl/fr/about-us/', title: 'À propos de nous' },
        { href: 'https://www.wingie.pl/fr/privacy/', title: 'Confidentialité' },
        { href: 'https://www.wingie.pl/fr/terms-and-conditions/', title: 'Conditions générales' },
        { href: 'https://www.wingie.pl/fr/awards/', title: 'Nos prix' },
      ],
    },
  ],
  'pl-pt': [
    {
      title: 'Mais',
      items: [
        { href: 'https://www.wingie.pl/pt/contact/', title: 'Contato' },
        // { href: 'https://www.wingie.pl/pt/faq/', title: 'Perguntas frequentes' },

        { href: 'https://www.wingie.pl/pt/about-us/', title: 'Sobre nós' },
        { href: 'https://www.wingie.pl/pt/privacy/', title: 'Privacidade' },
        { href: 'https://www.wingie.pl/pt/terms-and-conditions/', title: 'Termos e condições' },
        { href: 'https://www.wingie.pl/pt/awards/', title: 'Nossos prêmios' },
      ],
    },
  ],
  'pl-ro': [
    {
      title: 'Mai mult',
      items: [
        { href: 'https://www.wingie.pl/ro/contact/', title: 'Contact' },
        // { href: 'https://www.wingie.pl/ro/faq/', title: 'Întrebări frecvente' },

        { href: 'https://www.wingie.pl/ro/about-us/', title: 'Despre noi' },
        { href: 'https://www.wingie.pl/ro/privacy/', title: 'Confidențialitate' },
        { href: 'https://www.wingie.pl/ro/terms-and-conditions/', title: 'Termeni și condiții' },
        { href: 'https://www.wingie.pl/ro/awards/', title: 'Premiile noastre' },
      ],
    },
  ],
  'pl-pl': [
    {
      title: 'Więcej',
      items: [
        { title: 'Kontakt', href: 'https://www.wingie.pl/contact/' },
        // { title: 'Często zadawane pytania', href: 'https://www.wingie.pl/faq/' },

        { title: 'O nas', href: 'https://www.wingie.pl/about-us/' },
        { title: 'Prywatność', href: 'https://www.wingie.pl/privacy/' },
        { title: 'Warunki użytkowania', href: 'https://www.wingie.pl/terms-and-conditions/' },
        { title: 'Nasze nagrody', href: 'https://www.wingie.pl/awards/' },
      ],
    },
  ],
  'pl-lt': [
    {
      title: 'Daugiau',
      items: [
        { href: 'https://www.wingie.pl/lt/contact/', title: 'Kontaktai' },
        // { href: 'https://www.wingie.pl/lt/faq/', title: 'Dažnai užduodami klausimai' },

        { href: 'https://www.wingie.pl/lt/about-us/', title: 'Apie mus' },
        { href: 'https://www.wingie.pl/lt/privacy/', title: 'Privatumas' },
        { href: 'https://www.wingie.pl/lt/terms-and-conditions/', title: 'Taisyklės ir sąlygos' },
        { href: 'https://www.wingie.pl/lt/awards/', title: 'Mūsų apdovanojimai' },
      ],
    },
  ],
  'pl-uz': [
    {
      title: "Ko'proq",
      items: [
        { href: 'https://www.wingie.pl/uz/contact/', title: 'Aloqa' },
        // { href: 'https://www.wingie.pl/uz/faq/', title: "Tez-tez so'raladigan savollar" },

        { href: 'https://www.wingie.pl/uz/about-us/', title: 'Biz haqimizda' },
        { href: 'https://www.wingie.pl/uz/privacy/', title: 'Maxfiylik' },
        { href: 'https://www.wingie.pl/uz/terms-and-conditions/', title: 'Shartlar va qoidalar' },
        { href: 'https://www.wingie.pl/uz/awards/', title: 'Bizning mukofotlarimiz' },
      ],
    },
  ],
  'pl-sr': [
    {
      title: 'Више',
      items: [
        { href: 'https://www.wingie.pl/sr/contact/', title: 'Контакт' },
        // { href: 'https://www.wingie.pl/sr/faq/', title: 'Често постављана питања' },

        { href: 'https://www.wingie.pl/sr/about-us/', title: 'О нама' },
        { href: 'https://www.wingie.pl/sr/privacy/', title: 'Приватност' },
        { href: 'https://www.wingie.pl/sr/terms-and-conditions/', title: 'Услови коришћења' },
        { href: 'https://www.wingie.pl/sr/awards/', title: 'Наша признања' },
      ],
    },
  ],
  'pl-ky': [
    {
      title: 'Көбүрөөк',
      items: [
        { href: 'https://www.wingie.pl/ky/contact/', title: 'Байланыш' },
        // { href: 'https://www.wingie.pl/ky/faq/', title: 'Көп берилүүчү суроолор' },

        { href: 'https://www.wingie.pl/ky/about-us/', title: 'Биз жөнүндө' },
        { href: 'https://www.wingie.pl/ky/privacy/', title: 'Купуялык' },
        { href: 'https://www.wingie.pl/ky/terms-and-conditions/', title: 'Шарттар жана эрежелер' },
        { href: 'https://www.wingie.pl/ky/awards/', title: 'Биздин сыйлыктар' },
      ],
    },
  ],
  'pl-tg': [
    {
      title: 'Бештар',
      items: [
        { href: 'https://www.wingie.pl/tg/contact/', title: 'Алоқа' },
        // { href: 'https://www.wingie.pl/tg/faq/', title: 'Саволҳои зуд-зуд пурсида мешаванда' },

        { href: 'https://www.wingie.pl/tg/about-us/', title: 'Дар бораи мо' },
        { href: 'https://www.wingie.pl/tg/privacy/', title: 'Махфият' },
        { href: 'https://www.wingie.pl/tg/terms-and-conditions/', title: 'Шартҳо ва қоидаҳо' },
        { href: 'https://www.wingie.pl/tg/awards/', title: 'Мукофотҳои мо' },
      ],
    },
  ],
  'pl-kk': [
    {
      title: 'Көбірек',
      items: [
        { href: 'https://www.wingie.pl/kk/contact/', title: 'Байланыс' },
        // { href: 'https://www.wingie.pl/kk/faq/', title: 'Жиі қойылатын сұрақтар' },

        { href: 'https://www.wingie.pl/kk/about-us/', title: 'Біз туралы' },
        { href: 'https://www.wingie.pl/kk/privacy/', title: 'Құпиялық' },
        { href: 'https://www.wingie.pl/kk/terms-and-conditions/', title: 'Шарттар мен ережелер' },
        { href: 'https://www.wingie.pl/kk/awards/', title: 'Біздің марапаттарымыз' },
      ],
    },
  ],
  'pl-nl': [
    {
      title: 'Meer',
      items: [
        { href: 'https://www.wingie.pl/nl/contact/', title: 'Contact' },
        // { href: 'https://www.wingie.pl/nl/faq/', title: 'Veelgestelde vragen' },

        { href: 'https://www.wingie.pl/nl/about-us/', title: 'Over ons' },
        { href: 'https://www.wingie.pl/nl/privacy/', title: 'Privacy' },
        { href: 'https://www.wingie.pl/nl/terms-and-conditions/', title: 'Algemene voorwaarden' },
        { href: 'https://www.wingie.pl/nl/awards/', title: 'Onze awards' },
      ],
    },
  ],
  'pl-ja': [
    {
      title: 'もっと',
      items: [
        { title: 'お問い合わせ', href: 'https://www.wingie.pl/ja/contact/' },
        { title: 'よくある質問', href: 'https://www.wingie.pl/en/faq/' },
        { title: '会社概要', href: 'https://www.wingie.pl/ja/about-us/' },
        { title: 'プライバシーポリシー', href: 'https://www.wingie.pl/ja/privacy/' },
        { title: '利用規約', href: 'https://www.wingie.pl/ja/terms-and-conditions/' },
        { title: '受賞歴', href: 'https://www.wingie.pl/ja/awards/' },
      ],
    },
  ],
  'pl-zh': [
    {
      title: '更多',
      items: [
        { title: '联系方式', href: 'https://www.wingie.pl/zh/contact/' },
        { title: '常见问题', href: 'https://www.wingie.pl/en/faq/' },
        { title: '关于我们', href: 'https://www.wingie.pl/zh/about-us/' },
        { title: '隐私政策', href: 'https://www.wingie.pl/zh/privacy/' },
        { title: '条款和条件', href: 'https://www.wingie.pl/zh/terms-and-conditions/' },
        { title: '我们的奖项', href: 'https://www.wingie.pl/zh/awards/' },
      ],
    },
  ],
  'pl-ko': [
    {
      title: '더보기',
      items: [
        { title: '연락처', href: 'https://www.wingie.pl/ko/contact/' },
        { title: '자주 묻는 질문', href: 'https://www.wingie.pl/en/faq/' },
        { title: '회사 소개', href: 'https://www.wingie.pl/ko/about-us/' },
        { title: '개인정보처리방침', href: 'https://www.wingie.pl/ko/privacy/' },
        { title: '이용약관', href: 'https://www.wingie.pl/ko/terms-and-conditions/' },
        { title: '수상 내역', href: 'https://www.wingie.pl/ko/awards/' },
      ],
    },
  ],
  'pl-hi': [
    {
      title: 'अधिक',
      items: [
        { title: 'संपर्क करें', href: 'https://www.wingie.pl/hi/contact/' },
        { title: 'सामान्य प्रश्न', href: 'https://www.wingie.pl/en/faq/' },
        { title: 'हमारे बारे में', href: 'https://www.wingie.pl/hi/about-us/' },
        { title: 'गोपनीयता', href: 'https://www.wingie.pl/hi/privacy/' },
        { title: 'नियम और शर्तें', href: 'https://www.wingie.pl/hi/terms-and-conditions/' },
        { title: 'हमारे पुरस्कार', href: 'https://www.wingie.pl/hi/awards/' },
      ],
    },
  ],
  'pl-ta': [
    {
      title: 'மேலும்',
      items: [
        { title: 'தொடர்பு', href: 'https://www.wingie.pl/ta/contact/' },
        { title: 'அடிக்கடி கேட்கப்படும் கேள்விகள்', href: 'https://www.wingie.pl/en/faq/' },
        { title: 'எங்கள் பற்றி', href: 'https://www.wingie.pl/ta/about-us/' },
        { title: 'தனியுரிமை', href: 'https://www.wingie.pl/ta/privacy/' },
        { title: 'விதிமுறைகள்', href: 'https://www.wingie.pl/ta/terms-and-conditions/' },
        { title: 'எங்கள் விருதுகள்', href: 'https://www.wingie.pl/ta/awards/' },
      ],
    },
  ],
  'pl-th': [
    {
      title: 'เพิ่มเติม',
      items: [
        { title: 'ติดต่อเรา', href: 'https://www.wingie.pl/th/contact/' },
        { title: 'คำถามที่พบบ่อย', href: 'https://www.wingie.pl/en/faq/' },
        { title: 'เกี่ยวกับเรา', href: 'https://www.wingie.pl/th/about-us/' },
        { title: 'นโยบายความเป็นส่วนตัว', href: 'https://www.wingie.pl/th/privacy/' },
        { title: 'ข้อกำหนดและเงื่อนไข', href: 'https://www.wingie.pl/th/terms-and-conditions/' },
        { title: 'รางวัลของเรา', href: 'https://www.wingie.pl/th/awards/' },
      ],
    },
  ],
  'pl-ur': [
    {
      title: 'مزید',
      items: [
        { title: 'رابطہ کریں', href: 'https://www.wingie.pl/ur/contact/' },
        { title: 'عمومی سوالات', href: 'https://www.wingie.pl/en/faq/' },
        { title: 'ہمارے بارے میں', href: 'https://www.wingie.pl/ur/about-us/' },
        { title: 'رازداری', href: 'https://www.wingie.pl/ur/privacy/' },
        { title: 'شرائط و ضوابط', href: 'https://www.wingie.pl/ur/terms-and-conditions/' },
        { title: 'ہمارے اعزازات', href: 'https://www.wingie.pl/ur/awards/' },
      ],
    },
  ],
  'pl-ka': [
    {
      title: 'მეტი',
      items: [
        { title: 'კონტაქტი', href: 'https://www.wingie.pl/ka/contact/' },
        { title: 'ხშირად დასმული კითხვები', href: 'https://www.wingie.pl/en/faq/' },
        { title: 'ჩვენ შესახებ', href: 'https://www.wingie.pl/ka/about-us/' },
        { title: 'კონფიდენციალურობა', href: 'https://www.wingie.pl/ka/privacy/' },
        { title: 'წესები და პირობები', href: 'https://www.wingie.pl/ka/terms-and-conditions/' },
        { title: 'ჩვენი ჯილდოები', href: 'https://www.wingie.pl/ka/awards/' },
      ],
    },
  ],
}
